import * as R from "ramda";

export const byTeam = team =>
  R.pipe(
    R.groupBy(R.propOr(undefined, "team")),
    R.propOr([], team)
  );

export const assocNotifications = notifications => opportunities =>
  R.map(opportunity =>
    R.assoc(
      "notifications",
      R.propOr({}, opportunity.id, notifications),
      opportunity
    )
  )(opportunities);
